import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  globalState,
  initialState
} from '@/globalStore/globalSlice/initialState.ts'
import { LoggedUser } from '@/core/types/LoggedUser.ts'
import { SystemModuleName } from '@/core/types/SystemModuleName.ts'

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload
    },
    setLoggedUser: (state, action: PayloadAction<LoggedUser>) => {
      state.loggedUser = action.payload
    },
    setLoggedUserStatus: (
      state,
      action: PayloadAction<globalState['loggedUserStatus']>
    ) => {
      state.loggedUserStatus = action.payload
    },
    setCurrentModuleName: (
      state,
      action: PayloadAction<SystemModuleName | null>
    ) => {
      state.currentModuleName = action.payload
    },
    setIsSidebarOpen(state, action: PayloadAction<boolean>) {
      state.isSidebarOpen = action.payload
    },
    setLinkAccountModalOpen(state, action: PayloadAction<boolean>) {
      state.isLinkAccountModalOpen = action.payload
    },
    setBranchOfficeLocationModalOpen(state, action: PayloadAction<boolean>) {
      state.isBranchOfficeLocationModalOpen = action.payload
    },
    reset: () => initialState
  }
})

export const globalActions = globalSlice.actions
export const { reducer: globalReducer } = globalSlice
